import { ART } from "../assets";
import { Reveal } from "./Reveal";

const flow = [
  { n: "01", title: "Upload photos", desc: "Snap or drop a few — that's all we need." },
  { n: "02", title: "AI does the math", desc: "Items, volume, labor, donation — read in seconds." },
  { n: "03", title: "Estimate ready", desc: "A clear, honest price. No surprises." },
  { n: "04", title: "Book pickup", desc: "Pick a window. We bring the muscle." },
];

export default function AIEstimate({ onStart }) {
  return (
    <section className="relative overflow-hidden py-24 sm:py-32 lg:py-40">
      <div className="pointer-events-none absolute right-0 top-1/3 h-96 w-96 rounded-full bg-lavender/40 blur-3xl" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid items-center gap-16 lg:grid-cols-2">
          {/* illustration */}
          <Reveal className="order-2 lg:order-1">
            <div className="relative">
              <div className="overflow-hidden rounded-[2.5rem] bg-white/50">
                <img src={ART.phoneUpload} alt="Uploading a photo from a phone" className="w-full animate-float-slow" />
              </div>
            </div>
          </Reveal>

          {/* copy + stepper */}
          <div className="order-1 lg:order-2 lg:pl-6">
            <Reveal>
              <p className="text-sm font-semibold uppercase tracking-[0.2em] text-violet/70">
                The estimate
              </p>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-5 font-display text-4xl leading-[1.02] tracking-tight text-charcoal sm:text-5xl lg:text-6xl text-balance">
                No forms to dread. Just a photo.
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-6 max-w-md text-lg leading-relaxed text-charcoal/60">
                The technology stays out of sight. You see a price, a plan, and a
                clear room ahead — nothing that feels like software.
              </p>
            </Reveal>

            <Reveal delay={0.15}>
              <ol className="mt-10 space-y-2">
                {flow.map((f) => (
                  <li
                    key={f.n}
                    data-testid={`flow-step-${f.n}`}
                    className="group flex items-start gap-5 rounded-3xl px-5 py-4 transition-colors duration-300 hover:bg-white/60"
                  >
                    <span className="font-display text-2xl text-violet/40 transition-colors group-hover:text-violet">
                      {f.n}
                    </span>
                    <div>
                      <p className="text-lg font-semibold text-charcoal">{f.title}</p>
                      <p className="text-charcoal/55">{f.desc}</p>
                    </div>
                  </li>
                ))}
              </ol>
            </Reveal>

            <Reveal delay={0.2}>
              <button
                onClick={onStart}
                data-testid="estimate-section-cta"
                className="mt-9 inline-flex items-center gap-3 rounded-full bg-violet px-8 py-4 text-base font-semibold text-white transition-all duration-300 hover:bg-violet-deep hover:-translate-y-0.5 hover:shadow-[0_18px_40px_-12px_rgba(76,0,140,0.5)]"
              >
                Get an instant quote <span>→</span>
              </button>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
